import moment from "moment";
import React, { Fragment, useEffect, useRef, useState, forwardRef, useCallback  } from 'react';
import { Input, InputNumber, Button, Table, notification, Drawer, Popconfirm, Pagination, Dropdown, Menu, Select, DatePicker } from 'antd';
import viVN from 'antd/es/date-picker/locale/vi_VN';
import * as SystemConfig from '../../../../configure/systemConfig';
import * as Actions from '../../../../libs/actions';
import * as AuthServices from '../../../../services/authServices';
import * as CoporationServices from "../../../../services/CorporationServices";
import * as ChiDinhService from '../../../../services/chiDinhService';
import * as PascService from '../../../../services/pascService';
import Notify, { NotifyStatus } from '../../../../components/notify';
import List from './list';
import Chart from './chart';
import SiteFilter from "../../../../configureHIS/common/siteFilter";

export default forwardRef((props, ref) => {
  //#region biến cục bộ
  const { Option } = Select;
  const now = new Date();
  const viewTypeEnum = {
    chart: "chart",
    list: "list"
  };
  //#endregion
  const listRef = useRef();
  const chartRef = useRef();
  const notiRef = useRef(null);
  const _hiddenLink = useRef();
  const firstRender = useRef(true);
  //#region khai báo state
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  //state paging và sorting
  //search/filter
  const [siteIds, setSiteIds] = useState([]);
  const [coporationId, setCoporationId] = useState();
  const [paymentTypeIds, setPaymentTypeIds] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment(now).add(-29,'days'));//(new moment((now).setMonth(now.getMonth() - 1)));
  const [dateTo, setDateTo] = useState(new moment());
  const [loaiCDHA, setLoaiCDHA] = useState();
  const [vpCDHAs, setVpCDHAs] = useState([]);
  //other
  const [listSites, setListSites] = useState([]);
  const [listCoporations, setListCoporations] = useState([]);
  const [listLoaiCDHAs, setListLoaiCDHAs] = useState([]);
  const [listVPCDHAs, setListVPCDHAs] = useState([]);
  const [viewType, setViewType] = useState(viewTypeEnum.chart);
  //#endregion
  
  //#region useEffect
  useEffect(() => {
    if (firstRender.current) return;
    loadChartOrList();
  }, [viewType]);
  
  useEffect(() => {
    console.clear();
    getListCoporations();
    getListLoaiCDHA();
    onClickStatisticHandle();
    firstRender.current = false;
  }, []);
  //#endregion 
  //#region get list data cho bộ lọc
  const getListCoporations = () => {
    CoporationServices.GetAllCoporation('', false, 1, 1000).then(result => {
      if (result.isSuccess) {
        setListCoporations(result.data);
        notiRef && notiRef.current.Close();
      }
      else {
        notiRef.current.Show(result.error.messageText, NotifyStatus.Error);
      }
    }).catch(err => {
      if (err.error && err.error.messageText)
        notiRef.current.Show(err.error.messageText, NotifyStatus.Error);
      else notiRef.current.Show(err, NotifyStatus.Error);
    }).finally(() => {
        forceUpdate();
    })
  }
  const getListLoaiCDHA = () => {
    ChiDinhService.DanhSachLoaiChiDinh('', 3).then(result => {
      if (result.isSuccess) {
        setListLoaiCDHAs(result.data);
      }
    }).catch(err => {
      notification.error({ message: "Tải dữ liệu [Loại CĐHA] bị lỗi" });
    }).finally(() => {
      forceUpdate();
    });
  }
  const getListVPCDHA = (loaiCDHA) => {
    let cdhaKeyword = '';
    PascService.LoaiVPCDHA(loaiCDHA, cdhaKeyword).then(result => {
      if (result.isSuccess) {
        setListVPCDHAs(result.data);
      }
    }).catch(err => {
        notification.error({ message: "Tải dữ liệu [danh sách CĐHA] bị lỗi" });
    }).finally(() => {
      forceUpdate();
    });
  }
  //#endregion 

  const loadChartOrList = () => {
    if (viewType == viewTypeEnum.chart)
      chartRef.current.loadData();
    else listRef.current.loadData();
  }

  const validate = () => {
    let listErr = [];
    if (!dateFrom) listErr.push('Phải nhập ngày lập phiếu');
    if (dateFrom > dateTo) listErr.push('Ngày lập phiếu từ phải nhỏ hơn ngày lập phiếu đến');
    if (loaiCDHA && (vpCDHAs.length < 1 || vpCDHAs.length > 5)) listErr.push('Số lượng Dịch vụ CĐHA tối thiểu 1, tối đa 5');
    return listErr;
  }

  const onClickStatisticHandle = () => {
    let listErr = validate();
    if (listErr.length > 0) {
      let err = listErr.join('\n');
      notiRef.current.Show(err, NotifyStatus.Error);
      return;
    }
    notiRef && notiRef.current.Close();
    loadChartOrList();
  }

  return (
    <React.Fragment>
      <a href="#download" style={{ display: 'none' }} ref={_hiddenLink} >download</a>
      <div className={"list-page" + (props.isDialog ? "" : " containerChilderWrapper")} >
          <div className="list-page-header" style={{ display: 'flex', justifyContent: 'space-between' }}> {/* header */}
              <h3>Thống kê doanh thu chẩn đoán hình ảnh (CĐHA)</h3>
              <h3 hidden={!props.isDialog}
                onClick={() => {
                  props.onCancel()
                }}
              ><i className='far fa-times-circle' /></h3>
          </div>
          <div className="list-page-body overflow-auto">{/* body */}
            <div className="row">{/* notification */}
              <div className="col-md-12"><Notify ref={notiRef} /></div>
            </div>
            <div className="list-page-search">{/* search/filter */}
              <div className="row">{/* Chi nhánh */}
                <SiteFilter updateSeletedSite={(listSite) => { setSiteIds(listSite) }} />
              </div>
              <div className="row mt-2">{/* Nguồn khách hàng | Ngày lập phiếu */}
                  <div className='col-md-6 d-flex flex-column'>{/* Nguồn khách hàng */}
                    <div>
                      <label>Nguồn khách hàng</label>
                    </div>
                    <Select
                      allowClear
                      className="w-100"
                      placeholder="Chọn nguồn khách hàng"
                      maxTagCount= 'responsive'
                      value={ coporationId }
                      onChange={(value) => {setCoporationId(value);}}
                    >
                    {(listCoporations ?? []).map((record, index) => {
                      return (
                        <Option key={record.ma} value={record.ma}>{record.ten}</Option>
                      )
                    })}
                    </Select>
                  </div>
                  <div className='col-md-6 d-flex flex-column'>{/* Ngày lập phiếu */}
                    <div>
                      <label>Ngày lập phiếu</label>
                    </div>
                    <div className="d-flex">
                      <DatePicker 
                        allowClear={false}
                        locale={viVN}
                        showNow={false}
                        className="w-100"
                        placeholder={"Từ ngày"}
                        value={dateFrom}
                        format = { SystemConfig.FORMAT_DATE }
                        onChange={(e) => { 
                          setDateFrom(e ? moment(e) : null);
                        }}
                      />
                      <div className="m-auto">&#160;-&#160;</div>
                      <DatePicker 
                        allowClear={false}
                        locale={viVN}
                        showNow={false}
                        className="w-100"
                        placeholder={"Đến ngày"}
                        value={dateTo}
                        format = { SystemConfig.FORMAT_DATE }
                        onChange={(e) => { 
                          setDateTo(e ? moment(e) : null);
                        }}
                      />
                    </div>
                  </div>
              </div>
              <div className="row mt-2">{/* Loại viện phí | dịch vụ */}
                  <div className='col-md-6 d-flex flex-column'>{/* Loại viện phí */}
                    <div>
                      <label>Loại dịch vụ</label>
                    </div>
                    <Select
                      allowClear
                      className="w-100"
                      placeholder="Chọn loại dịch vụ"
                      maxTagCount= 'responsive'
                      value={ loaiCDHA }
                      onChange={(value) => { setLoaiCDHA(value); setVpCDHAs([]); getListVPCDHA(value); }}
                    >
                    {(listLoaiCDHAs ?? []).map((record, index) => {
                      return (
                        <Option key={record.value} value={record.value}>{record.label}</Option>
                      )
                    })}
                    </Select>
                  </div>
                  <div className='col-md-6 d-flex flex-column'>{/* Loại viện phí */}
                    <div>
                      <label>Dịch vụ CĐHA</label>
                    </div>
                    <Select
                      mode="multiple"
                      allowClear
                      className="w-100"
                      placeholder="Chọn dịch vụ"
                      maxTagCount= 'responsive'
                      value={ vpCDHAs }
                      onChange={(value) => {setVpCDHAs(value);}}
                      showSearch
                      filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                    {(listVPCDHAs ?? []).map((record, index) => {
                      return (
                        <Option key={record.value} value={parseInt(record.value)}>{record.label}</Option>
                      )
                    })}
                    </Select>
                  </div>
              </div>
              <div className="row mt-2">{/* button Thống kê */}
                  <div className='col-md-12 d-flex justify-content-end'>
                    <label className="my-auto">Hiển thị: </label>
                    <Select
                      // placeholder="Chọn hình thức thanh toán"
                      className="ml-2"
                      style={{ minWidth:"130px" }}
                      maxTagCount= 'responsive'
                      value={ viewType }
                      onChange={(value) => {setViewType(value);}}
                    >
                      <Option key="chart" value="chart"><i className='far fa-chart-bar mr-2'></i> Biểu đồ</Option>
                      <Option key="list" value="list"><i className='fas fa-list mr-2'></i> Danh sách</Option>
                    </Select>
                    <button 
                      className='btn btn-color ml-2' 
                      onClick={() => {
                        onClickStatisticHandle();
                      }}
                    >
                      <i className='far fa-chart-bar mr-2'></i>
                      Thống kê
                    </button>
                  </div>
              </div>
            </div>
            <div className="row mt-2">{/* Dashboard & [Chart | List] */}
              <div key="chart" className='col-md-12' hidden={viewType != viewTypeEnum.chart}>
                <Chart ref={chartRef}
                  siteIds={siteIds}
                  coporationIds={coporationId ? [coporationId] : []}
                  loaiCDHA={loaiCDHA}
                  vpCDHAs={vpCDHAs}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                ></Chart>
              </div>
              <div key="list" className='col-md-12' hidden={viewType != viewTypeEnum.list}>
                <List ref={listRef}
                  siteIds={siteIds}
                  coporationIds={coporationId ? [coporationId] : []}
                  loaiCDHA={loaiCDHA}
                  vpCDHAs={vpCDHAs}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                ></List>
              </div>
            </div>
          </div>
          <div className={props.isDialog ? "list-page-footer d-flex justify-content-between mt-2" : "d-none"}
          >{/* footer (nếu có) */}
            <div>
            </div>
          </div>
      </div>
    </React.Fragment>
  );
})